import { MDSIconKind } from "@/mds/components/icon/icon/icon.types";
import { ButtonProps } from "react-aria-components";

export enum MDSIconButtonVariant {
  Default = "default",
  TabBar = "tabBar",
  Transparent = "transparent",
  Chrome = "chrome",
  OnAccent = "onAccent",
  OnChrome = "onChrome",
  OnEmphasis = "onEmphasis",
  Brand = "brand",
  Floating = "floating",
}

export enum MDSIconButtonSize {
  XSmall = "x-small",
  Small = "small",
  Medium = "medium",
}

export interface IMDSIconButtonProps extends Omit<ButtonProps, "children"> {
  variant?: MDSIconButtonVariant;
  size?: MDSIconButtonSize;
  iconKind: MDSIconKind | (() => React.ReactNode);
  rounded?: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  isToggled?: boolean;
}
